/* global BMS */
import gamesConfig from './configurations/gamesConfig.json';
import disabledGamesConfig from './configurations/disabledGamesConfig.json';
import startingCategory from './configurations/category.json';
import subCategory from "./configurations/subCategory.json"
// This object is to be injected by virgo

export const VIRTUALS = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? gamesOrderCorrection(gamesConfig)
    : BMS
        ? gamesOrderCorrection(BMS.games)
        : {};

export const DISABLED_VIRTUALS = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? disabledGamesConfig
    : BMS
        ? BMS.disabledGames
        : {};

export const STARTING_CATEGORY = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? startingCategory.category
    : BMS
        ? BMS.category
        : {};

export const STARTING_SUBCATEGORY = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? subCategory.channel
    : BMS
        ? BMS.subCategory
        : {};

export function gamesOrderCorrection(games) {
    let displayOrder = 0;
    let oldDisplayOrder = 0;
    games.forEach((val) => {
        if (oldDisplayOrder < val.category.displayOrder) {
            displayOrder = displayOrder + 1;
        }
        if (val.category.displayOrder != displayOrder) {
            oldDisplayOrder = val.category.displayOrder;
            val.category.displayOrder = displayOrder;
        } else {
            oldDisplayOrder = displayOrder;
        }


    });
    return games;
}



// WEBPACK FOOTER //
// ./src/constants/games.js